import { useCreateNormalCarleadForm } from './useCreateNormalCarleadForm';
import { useStep1BaseProps } from './useStep1BaseProps';
export function useStep1CarleadForm() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [['manufacturer', 'mainType', 'builtDate']];
  const step1Props = useStep1BaseProps();
  const consumerForm = useCreateNormalCarleadForm([step1Props, {
    createSteps: [function step1Steps() {
      return typeof steps === 'function' ? steps(...arguments) : steps;
    }]
  }, ...params]);
  return consumerForm;
}